<template>
  <f7-popup id="maintenance" @popup:opened="open">
    <f7-view>
      <f7-pages>
        <f7-page navbar-fixed toolbar-fixed>
          <f7-navbar>
            <f7-nav-left>
              <f7-link @click="close">{{ $t('result_ui.close') }}</f7-link>
            </f7-nav-left>
            <f7-nav-center>Maintenance</f7-nav-center>
            <f7-nav-right>
              <f7-link @click="saveConfig">{{ $t('result_ui.save') }}</f7-link>
            </f7-nav-right>
          </f7-navbar>

          <f7-tabs>
            <f7-tab id="tab1" active>
              <f7-block-title v-show="maintenance">Device operations</f7-block-title>
              <f7-list form v-show="maintenance">
                <f7-list-item title="Current state">
                  <div slot="after">{{ uiState }}</div>
                </f7-list-item>
                <f7-list-item
                  title="Application"
                  :class="{'disabled': appReady !== 'STOPPED' && appReady !== 'STARTED'}"
                >
                  <div slot="after">
                    <f7-input
                      @change="handleAppState"
                      :checked="appState"
                      :disabled="appReady !== 'STOPPED' && appReady !== 'STARTED'"
                      type="switch"
                    ></f7-input>
                  </div>
                </f7-list-item>

                <f7-list-item
                  title="App Mode"
                  :class="{'disabled': appReady !== 'STOPPED' || appState === true}"
                >
                  <div slot="after">{{ wMode }}</div>
                </f7-list-item>
              </f7-list>

              <f7-block-title v-show="maintenance">Calibration</f7-block-title>
              <f7-list
                media-list
                :class="{'disabled': appReady !== 'STOPPED' || appState === true}"
                v-show="maintenance"
              >
                <f7-list-item link="#" @click="startCalibration" title="Start calibration"></f7-list-item>
              </f7-list>

              <f7-block-title>Options</f7-block-title>

              <f7-list form :class="{'disabled': maintenance && (appReady !== 'STOPPED' || appState === true)}">
                <f7-list-item v-for="s in settings" :key="s.id" :title="options[s.key].name">
                  <div slot="after">
                    <f7-input v-if="typeDict[s.value_type]=='text'" v-model="s.value" type="text"></f7-input>
                    <f7-input
                      v-if="typeDict[s.value_type]=='switch'"
                      type="switch"
                      :checked="s.value"
                      @change="s.value = $event.target.checked"
                    ></f7-input>
                  </div>
                </f7-list-item>
                <f7-list-label v-show="!maintenance">In order to activate new options please power off and power on the device using its button.</f7-list-label>
              </f7-list>

              <div>&nbsp;&nbsp;&nbsp;v.{{ version }}</div>
              <f7-block-title>&nbsp;</f7-block-title>
              <f7-block-title>&nbsp;</f7-block-title>

            </f7-tab>
            <f7-tab id="tab2">
              <f7-block-title>OUTPUT</f7-block-title>
              <f7-list :class="{'disabled': appReady !== 'STOPPED' || appState === true}">
                <f7-list-item title="Valve">
                  <div slot="after">
                    <f7-input
                      @change="handleState('valve')"
                      :checked="state.valve"
                      :disabled="appReady !== 'STOPPED'"
                      type="switch"
                    ></f7-input>
                  </div>
                </f7-list-item>
                <f7-list-item title="Pump">
                  <div slot="after">
                    <f7-input
                      @change="handleState('pump')"
                      :checked="state.pump"
                      :disabled="appReady !== 'STOPPED'"
                      type="switch"
                    ></f7-input>
                  </div>
                </f7-list-item>
              </f7-list>

              <f7-block-title>INPUT</f7-block-title>

              <f7-list form :class="{'disabled': appReady !== 'STOPPED' || appState === true}">
                <f7-list-item v-for="v in sensorValues" :key="v.id">
                  <div
                    slot="inner-start"
                    style="font-family: monospace; font-size:14px;"
                  >#{{ v.id }} - {{ v.content }}</div>
                </f7-list-item>
              </f7-list>
              <!-- <f7-grid no-gutter :class="{'disabled': appReady !== 'STOPPED' || appState === true}">
                <f7-col width="100">
                  <div class="data-table card">
                    <table>
                      <thead>
                        <tr>
                          <th class="numeric-cell">#</th>
                          <th class="numeric-cell">Weight</th>
                          <th class="numeric-cell">Speed</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="v in sensorValues" :key="v.id">
                          <td class="numeric-cell">{{ v.id }}</td>
                          <td class="numeric-cell">{{ v.weight }}</td>
                          <td class="numeric-cell">{{ v.speed }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </f7-col>
                <f7-col width="25"></f7-col>
              </f7-grid>-->
            </f7-tab>
            <f7-tab id="tab3">
              <f7-block-title>Events</f7-block-title>
              <f7-page infinite-scroll :infinite-scroll-preloader="(showPreloader && showEventList) || (!showEventList)" @infinite="loadMoreEvents">
                <f7-list v-show="events != []">
                  <f7-list-item v-for="event in events" :key="event.event_time">
                    <div v-bind:class="eventLevel(event.event_name)" class="item-title event-title">{{ event.event_name }} </div>
                    <div v-if="event.event_detail" class="item-subtitle event-subtitle">&emsp;{{ event.event_detail }}</div>
                    <div class="item-after event-after">{{ formatDate(event.event_time) }}</div>
                  </f7-list-item>
                </f7-list>
              </f7-page>
            </f7-tab>
          </f7-tabs>
          <f7-toolbar tabbar labels>
            <f7-link icon-f7="settings" text="Settings" active tab-link="#tab1"></f7-link>
            <f7-link icon-f7="layers_alt" text="Input/Output" tab-link="#tab2" v-show="maintenance"></f7-link>
            <f7-link icon-f7="timelapse" text="Events" tab-link="#tab3"></f7-link>
          </f7-toolbar>
        </f7-page>
      </f7-pages>
    </f7-view>
  </f7-popup>
</template>

<script>
import ReactiveDictClient from '../ReactiveDictClient'
import Settings from '../settings'
import _ from 'lodash'
// import EventBus from '../event-bus'

const mturl = path => 'http://' + Settings.host + ':5151' + path
const mtwsurl = path => 'ws://' + Settings.host + ':5151' + path
const wsurl = path => 'ws://' + Settings.host + ':6161' + path
const httpResponseTimeout = Settings.mHttpResponseTimeout || 5000
var db, dbmtws
var authdetail
var loading = false

export default {
  data () {
    return {
      state: {
        pump: undefined,
        valve: undefined
      },
      showPreloader: false,
      showEventList: true,
      searchBusy: false,
      appState: false,
      pumpState: false,
      valveState: false,
      sensorValues: [],
      sensorValuesIx: 1,
      appReady: 'NOT_KNOWN',
      settings: [],
      uiState: '',
      wMode: '-',
      typeDict: {
        string: 'text',
        number: 'text',
        float: 'text',
        bool: 'switch'
      },
      options: {
        'Institution': {name: 'Institution', order: 0},
        'PrinterDisabled': {name: 'Disable printer', order: 1},
        'Examination.StartUrination.Timeout': {name: 'Test start duration', order: 2},
        'Examination.FinishUrination.During': {name: 'Test finish duration', order: 3},
        'Examination.IgnoreIfTotalVolumeBelow': {name: 'Min. sufficient volume', order: 4},
        'Cleaner.StopEmptying.Limit': {name: 'Emptying limit', order: 5},
        'Cleaner.StopFilling.Limit': {name: 'Filling limit', order: 6},
        'Cleaner.StopFilling.Timeout': {name: 'Filling Timeout', order: 7},
        'Cleaner.StopEmptying.Timeout': {name: 'Emptying Timeout', order: 8},
        'VoiceGuidance': {name: 'Voice Guidance', order: 9},
        'SoundVolume': {name: 'Sound Volume', order: 10}
      },
      maintenance: false,
      version: '0.0.0.0',
      events: [],
      eventPage: 0
    }
  },
  computed: {
    eventLevelClasses () {
      return {
        AtmegaStarted: ['danger'],
        Barcode_MWL_multiple: ['danger'],
        Barcode_MWL_server_error: ['danger'],
        CalibrationFailed: ['danger'],
        ComputerIPFail: ['danger'],
        DeviceOffForced: ['danger'],
        EmptyingTimeout: ['danger'],
        FailedRPC: ['danger'],
        FillingTimeout: ['danger'],
        FloatValve: ['danger'],
        MalformedMessage: ['danger'],
        SoilMoisture: ['danger'],
        'UA.RemoteSignalTimeout': ['danger'],
        'UA.ResponseTimeout': ['danger'],
        'UA.ShiftFailure': ['danger'],
        UnhandledDigitalInput: ['danger'],
        WeightSensorNotStarted: ['danger'],
        UnexpectedSpeedOnExam: ['danger'],
        WeightSensorLag: ['danger'],
        UnstableSpeedOnStandby: ['note'],
        Barcode_MWL_not_found: ['warning'],
        Emergency: ['warning'],
        EmergencySpeed: ['warning'],
        EmergencyWeight: ['warning'],
        ExamIgnoreThreshold: ['warning'],
        ExamSkip: ['warning'],
        IOErrorBarcode: ['warning'],
        NoPaper: ['warning'],
        RTCDrift: ['warning'],
        UnstableWeightOnStandby: ['warning'],
        VpnHiccup: ['warning'],
        Barcode_MWL_bypass: ['success'],
        Barcode_NotIntegrated: ['success'],
        ComputerIPSuccess: ['success'],
        DeviceOffButton: ['success'],
        DeviceOffNormal: ['success'],
        ReadyToStart: ['success'],
        Touched: ['success'],
        VpnOn: ['success']
      }
    }
  },
  name: 'Maintenance',
  methods: {
    loadMoreEvents () {
      var vm = this

      if (loading || !vm.showEventList) return

      loading = true

      vm.showPreloader = true

      vm.$http
        .get(mturl('/event/' + vm.eventPage), {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(response => {
          if (response.body.length === 0) {
            vm.showPreloader = false
            return
          }
          for (const element of response.body.data) {
            var lastEvent = vm.events.slice(-1)
            if (lastEvent['event_time'] !== element['event_time']) {
              vm.events.push(element)
            }
          }
          vm.eventPage++
          loading = false
        }, response => {
          console.log('Error getting older events')
          loading = false
        })
    },
    eventLevel (name) {
      const classes = this.eventLevelClasses[name]
      if (Array.isArray(classes)) {
        return classes.join(' ')
      } else {
        return classes || ''
      }
    },
    formatDate (dateTimeString) {
      const dateTime = new Date(dateTimeString + 'Z')
      const formattedDate = dateTime.toLocaleDateString()
      const formattedTime = dateTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      return `${formattedTime} ${formattedDate}`
    },
    dene: function () {
      // var vm = this
      // vm.$f7.views.maintView.router.loadPage('maintenance')
      // console.log(vm.$f7.views)
      // vm.$f7.views.maintView.router.load({pageName: 'maintenance'})
    },
    close () {
      var vm = this

      vm.$http
        .get(mturl('/event/stop'), {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(response => {
          console.log(response)
        })
      vm.events = []
      vm.eventPage = 0
      db.close()
      dbmtws.close()
      vm.$f7.closeModal()
    },
    startCalibration () {
      var vm = this
      var warning = function () {
        vm.$f7.hidePreloader()
        vm.$f7.alert(
          'Unexpected situation in calibration. Please inform the manufacturer. You can retry calibration after restarting the device.',
          'Connection Error'
        )
      }
      vm.$http
        .get(mturl('/cal_step1'), {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(response => {
          console.log(response.body)
          vm.$f7.alert(
            '',
            'Please be sure that container is empty and click OK.',
            function () {
              vm.$f7.showPreloader('Please wait...')
              vm.$http
                .get(mturl('/cal_step2'), {
                  headers: { Authorization: 'Basic ' + authdetail }
                })
                .then(response => {
                  console.log(response.body)
                  vm.$f7.hidePreloader()
                  vm.$f7.alert(
                    '',
                    'Put the weight 500 gr. and click OK.',
                    function () {
                      vm.$f7.showPreloader('Please wait...')
                      vm.$http
                        .get(mturl('/cal_step3'), {
                          headers: { Authorization: 'Basic ' + authdetail }
                        })
                        .then(response => {
                          console.log(response.body)
                          vm.$f7.hidePreloader()
                          vm.$f7.alert(
                            '',
                            'Put the weight 1000 gr. and click OK.',
                            function () {
                              vm.$f7.showPreloader('Please wait...')
                              vm.$http
                                .get(mturl('/cal_step4'), {
                                  headers: {
                                    Authorization: 'Basic ' + authdetail
                                  }
                                })
                                .then(response => {
                                  console.log(response.body.result)
                                  vm.$f7.hidePreloader()
                                  if (response.body.result === 'SUCCESS') {
                                    vm.$f7.alert(
                                      '',
                                      'Calibration is successful.'
                                    )
                                  } else {
                                    vm.$f7.alert('', 'Calibration failed !')
                                  }
                                  console.log('Calibration Completed.')
                                }, warning)
                            }
                          ) // 1000 gr
                        }, warning)
                    }
                  ) // 500 gr
                }, warning)
            }
          ) // Hazenin bos..
        }, warning)
    },
    mInit () {
      console.log('Maintenance.init')
    },
    command (type) {
      var vm = this

      vm.$http
        .get(mturl('/' + type), {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(
          response => {
            console.log(response)
          },
          response => {
            console.log(response)
          }
        )
    },
    saveConfig () {
      var vm = this

      // vm.$f7.closeModal('.maintenanceLogin', true)

      // console.log(vm.settings)
      vm.$http
        .put(mturl('/config'), vm.settings, {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(
          response => {
            vm.$f7.alert('', 'Saved.')
            // console.log(response.body)
          },
          response => {
            vm.$f7.alert('', 'Hata !')
            console.log('Error !')
          }
        )
    },
    handleState (component) {
      var vm = this
      vm.state[component] = event.target.checked
      // console.log(component, vm.state[component])
      vm.$http
        .put(
          mturl('/output'),
          { component: component, state: vm.state[component] },
          { headers: { Authorization: 'Basic ' + authdetail } }
        )
        .then(
          response => {
            console.log('/output request succeeded.', response.body)
          },
          response => {
            console.log('/output request failed.')
          }
        )
    },
    handleAppState (event) {
      var vm = this
      // 'vm.appState = ' is handled in every case below:

      console.log(vm.appState, event.target.checked)

      var rollbackStart = function (resp) {
        console.log('Error:')
        console.log(resp)
        vm.appReady = 'STOPPED'
        vm.$f7.hidePreloader()
        event.target.checked = false
        vm.appState = event.target.checked
        vm.$f7.alert('', 'Connection Error')
      }
      var rollbackStop = function (resp) {
        console.log('Error:')
        console.log(resp)
        vm.appReady = 'STARTED'
        vm.$f7.hidePreloader()
        event.target.checked = true
        vm.appState = event.target.checked
        vm.$f7.alert('', 'Connection Error')
      }
      // DEVNOTE still there is unhandled state: After successfully (for example) /start request, if there is a connection error, the app could not understand if it started since WAIT_TO_START_BARCODE will never arrive to ReactiveDictClient

      if (event.target.checked) {
        // Starting app
        vm.$f7.modal({
          title: 'Please select the app mode',
          verticalButtons: true,
          buttons: [
            {
              text: 'Normal Mode',
              onClick: function () {
                vm.appState = event.target.checked
                vm.$f7.showPreloader('Please wait...')
                vm.appReady = 'ABOUT_TO_START'
                vm.$http
                  .get(mturl('/start'), {
                    headers: { Authorization: 'Basic ' + authdetail },
                    timeout: httpResponseTimeout
                  })
                  .then(response => {
                    console.log('/start request succeeded.', response.body)
                  }, rollbackStart)
              }
            },
            {
              text: 'Auto Test Mode',
              onClick: function () {
                vm.appState = event.target.checked
                vm.$f7.showPreloader('Please wait...')
                vm.appReady = 'ABOUT_TO_START'
                vm.$http
                  .get(mturl('/startAuto'), {
                    headers: { Authorization: 'Basic ' + authdetail },
                    timeout: httpResponseTimeout
                  })
                  .then(response => {
                    console.log('/startAuto request succeeded.', response.body)
                  }, rollbackStart)
              }
            },
            {
              text: 'Cancel',
              close: true,
              onClick: function () {
                event.target.checked = false
                vm.appState = event.target.checked
              }
            }
          ]
        })
      } else {
        // Stopping app
        vm.appState = event.target.checked
        vm.$f7.showPreloader('Please wait...')
        vm.appReady = 'ABOUT_TO_STOP'
        vm.$http
          .get(mturl('/stop'), {
            headers: { Authorization: 'Basic ' + authdetail },
            timeout: httpResponseTimeout
          })
          .then(response => {
            console.log('/stop request succeeded.', response.body)
          }, rollbackStop)
      }
    },
    initEnv () {
      var vm = this
      vm.state = {
        pump: undefined,
        valve: undefined
      }
      vm.appState = false
      vm.pumpState = false
      vm.valveState = false
      vm.sensorValues = []
      vm.sensorValuesIx = 1
      vm.appReady = 'NOT_KNOWN'
      vm.settings = []
      vm.uiState = ''
      vm.wMode = '-'
    },
    open () {
      var vm = this
      console.log(vm.$f7)
      vm.initEnv()

      var user = JSON.parse(localStorage.getItem('user'))
      authdetail = user.auth

      console.log('Maintenance.created')

      vm.sensorValues = new Array(1).fill({ id: 0, weight: 0, speed: 0 })

      vm.$f7.showPreloader('Please wait...')

      /* var setT = setTimeout(function () {
      vm.$f7.hidePreloader()
    }, httpResponseTimeout) */

      vm.$http
        .get(mturl('/config'), {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(
          response => {
            console.log('/config request succeeded.')
            console.log(response.body.data)
            vm.settings = _.sortBy(response.body.data, function (item) { console.log(item.key); return vm.options[item.key].order })
            vm.maintenance = response.body.m
          },
          response => {
            console.log('ERROR !')
          }
        )
      vm.$http
        .get(mturl('/version'), {
          headers: { Authorization: 'Basic ' + authdetail }
        })
        .then(
          response => {
            console.log('VERSION: ' + response.body)
            vm.version = response.body
          }
        )

      vm.loadMoreEvents()

      var addrmtws = mtwsurl('/websocket')
      var addr = wsurl('/websocket')

      dbmtws = new ReactiveDictClient(addrmtws, 'mtws')

      dbmtws.on('connected', function () {})

      dbmtws.on('WSManager/autoFlowAppState', function (
        isSnapshot,
        autoFlowAppState
      ) {
        console.log('autoFlowAppState', autoFlowAppState)
        if (autoFlowAppState === 0) {
          if (vm.appReady === 'ABOUT_TO_STOP' || vm.appReady === 'NOT_KNOWN') {
            vm.$f7.hidePreloader()
            vm.appReady = 'STOPPED'
          }
        } else {
          if (
            /* vm.appReady === 'ABOUT_TO_START' || */ vm.appReady ===
            'NOT_KNOWN'
          ) {
            vm.$f7.hidePreloader()
            vm.appReady = 'STARTED'
          } // About to start is handled in Examination/ui_state
        }
      })

      dbmtws.on('WSManager/digitalInput', function (isSnapshot, digitalInput) {
        if (!isSnapshot) {
          vm.sensorValues.unshift({
            id: vm.sensorValuesIx++,
            content: digitalInput
          })
        }
      })

      dbmtws.on('WSManager/vmic_qura', function (isSnapshot, vmicQura) {
        if (isSnapshot) {
          // console.log('snapshot', vmicQura)
        } else {
          // if (vm.sensorValues.length >= 10) vm.sensorValues.shift()
          vm.sensorValues.unshift({
            id: (vm.sensorValuesIx++),
            content: 'W:' + vmicQura[0] + ' - S:' + vmicQura[1]
          })
          // console.log('!snapshot', vmicQura)
        }
      })

      dbmtws.on('WSManager/event', function (isSnapshot, newEvent) {
        if (JSON.parse(newEvent) != null) {
          vm.events.unshift(JSON.parse(newEvent))
        }
      })

      dbmtws.connect()

      db = new ReactiveDictClient(addr)

      db.on('connecting', function () {
        vm.uiState = 'CONNECTING'
        vm.wMode = '-'
        // if (vm.appReady === 3) { vm.$f7.hidePreloader(); vm.appReady = 1 }
      })

      db.on('SOCKET_INFO/isLocal', function (isnp, val) {
        vm.isLocal = val
      })

      db.on('Examination/ui_state', function (isnp, st) {
        console.log('vm.appState', vm.appState)
        vm.uiState = st
        if (!vm.appState) {
          vm.appState = true
          vm.$f7.hidePreloader()
        }
        if (vm.appReady === 'ABOUT_TO_START') {
          /* clearTimeout(setT); */ vm.$f7.hidePreloader()
          vm.appReady = 'STARTED'
        }
        // WAIT_TO_START_BARCODE, WAIT_TO_START_TOUCH, EMERGENCY, URINATION, WAIT_TO_URINATE, CLEANING
      })

      db.on('Examination/working_mode', function (isnp, st) {
        vm.wMode = st
      })

      db.on('Examination/print_status', function (isnp, st) {
        vm.prState = st
        // READY, SKIPPED, DISABLED, PRINTING
      })

      db.connect()
    }
  }
}
</script>

<style scoped>
@import url('../assets/fonts/catamaran/catamaran.css');
@import url('../assets/fonts/bebas-neue/bebas-neue.css');

.event-title {
  font-size: 15px;
  line-height: 1.4;
  font-weight: normal;
}

.event-subtitle {
  color:#919196;
  font-size: 13px;
}

.event-after {
  color:#000000;
  font-size: 15px;
}
.danger {
  color: #ff0000;
}

.warning {
  color: #ffa500;
}

.note {
  color: #808080;
}

.success {
  color: #008000;
}
</style>



// WEBPACK FOOTER //
// src/components/Maintenance.vue